import * as React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import AddCircleIcon from '@mui/icons-material/AddCircle';

interface Props {
  name: string;
  values: any;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined,
  ) => void;
}

export default function ImageUpload({ name, values, setFieldValue }: Props) {
  const [imageURLs, setImageURLs] = React.useState<string[]>([]);

  React.useEffect(() => {
    if (values[name] === undefined || values[name].length < 1) return;
    const newImageUrls: string[] = [];
    values[name].forEach((image: File) =>
      newImageUrls.push(URL.createObjectURL(image)),
    );
    setImageURLs(newImageUrls);
  }, [values, name, setImageURLs]);

  function onImageChange(e: any) {
    setFieldValue(name, [...e.target.files]);
  }

  function printImages() {
    const imageURLElems: any[] = [];
    imageURLs.forEach(image => {
      imageURLElems.push(
        <Grid item md={3}>
          <img src={image} alt="Uploaded" />
        </Grid>,
      );
    });
    return imageURLElems;
  }

  return (
    <div className="imageUpload">
      <Grid container spacing={2} className="imagePreviews">
        {printImages()}
        <Grid item md={3}>
          <InputLabel className="image-label">
            <div>
              <div className="upload-icon">
                <AddCircleIcon color="primary" fontSize="large" />
              </div>
              <div className="upload-text">
                <Typography variant="body1">Add Photos</Typography>
              </div>
            </div>
            <input
              className="image-input"
              type="file"
              name={name}
              onChange={onImageChange}
              multiple
              hidden
              accept="image/*"
            />
          </InputLabel>
        </Grid>
      </Grid>
    </div>
  );
}
